/**
 * Optional BIBLE screenshot URLs for in-app Help.
 *
 * Production builds do not bundle `docs/BIBLE/screens/*.webp` — those assets are
 * documentation-only. Help articles may still list `images[].file` for prose
 * alignment; without a dev-time bundle they render as text-only.
 *
 * To experiment with bundled screenshots locally, replace `bibleScreenshotUrl`
 * with Vite imports (see git history) — do not wire that into release builds.
 */

export function bibleScreenshotUrl(_file: string): string {
  return "";
}

export function bibleScreenshotFiles(): string[] {
  return [];
}
